import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createMainSkin } from "../../../actions/mods_factory/mainSkinsActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, MainSkinInterface } from "../../../store/mods_factory/mainSkinsSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const newParams   = useAppSelector(state => state.modsFactory.mainSkins.newParams);
  const error       = useAppSelector(state => state.modsFactory.mainSkins.newError);
  const categories  = useAppSelector(state => state.modsFactory.categories.entities);

  let params = newParams;

  if (categories && newParams?.category_id) {
    const category = categories[newParams.category_id];
    params = { ...newParams };

    if (category?.parent_id) {
      params.category_id    = category.parent_id;
      params.subcategory_id = category.id;
    }
  }

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: MainSkinInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createMainSkin(data));

    if (createMainSkin.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-mainSkin'>
        <h6 className="v-content-label">Create Entity Skin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
